export const businessQuestions = {
  conversation1: {
    id: 1,
    title: "Guest Speaker Invitation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business1.mp3",
        script: `<mark>M</mark>: Hi, Olivia. Have we finalized the <mark>guest speaker</mark> for our annual business seminar?
<span class="translation">(안녕하세요, Olivia. 연례 비즈니스 세미나를 위한 초청 연사가 확정됐나요?)</span>

<mark>W</mark>: Not yet. We reached out to two potential speakers, but only <mark>one has responded</mark> so far.
<span class="translation">(아직이요. 두 명의 잠재 연사에게 연락했는데, 지금까지 한 명만 응답했어요.)</span>

<mark>M</mark>: Who is that?
<span class="translation">(누구인가요?)</span>

<mark>W</mark>: Dr. Jonathan Lee, a well-known marketing strategist. He's available on our event date, and his topic aligns well with our theme.
<span class="translation">(유명한 마케팅 전략가인 Jonathan Lee 박사입니다. 행사 날짜에 참석 가능하고, 그의 주제가 우리 테마와 잘 맞아요.)</span>

<mark>M</mark>: That sounds great. Should we go ahead and confirm his participation?
<span class="translation">(좋네요. 그의 참여를 확정지을까요?)</span>

<mark>W</mark>: Yes. I'll draft a <mark>formal invitation</mark> and send it by this afternoon.
<span class="translation">(네. 오후까지 공식 초청장을 작성해서 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A <mark>keynote speaker</mark> for an event",
          B: "A new business <mark>partnership</mark>",
          C: "A <mark>team-building</mark> workshop",
          D: "A corporate <mark>leadership</mark> <mark>change</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A keynote speaker for an event

대본 키워드: "Have we finalized the guest speaker for our annual business seminar?"
보기 키워드: "A keynote speaker for an event"

❌ 오답 트랩:
(B) A new business partnership 
→ 비즈니스 협력 관련 언급 없음

(C) A team-building workshop 
→ 팀 빌딩이 아니라 연사 초청 논의 중

(D) A corporate leadership change 
→ 리더십 교체 관련 언급 없음`,
      },
      {
        id: 2,
        question:
          "What does <mark>the woman</mark> say about the guest speaker selection?",
        options: {
          A: "The selected speaker is <mark>not</mark> <mark>available</mark>",
          B: "<mark>Only one speaker</mark> has responded so far",
          C: "The company is still <mark>reviewing</mark> <mark>options</mark>",
          D: "The <mark>CEO</mark> has chosen the speaker",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Only one speaker has responded so far

대본 키워드: "We reached out to two potential speakers, but only one has responded so far."
보기 키워드: "Only one speaker has responded so far"

❌ 오답 트랩:
(A) The selected speaker is not available 
→ 선택된 연사는 참석 가능함

(C) The company is still reviewing options 
→ 옵션 검토 중이 아님

(D) The CEO has chosen the speaker 
→ CEO가 선택했다는 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Send a <mark>formal</mark> <mark>invitation</mark>",
          B: "<mark>Postpone</mark> the event",
          C: "Contact <mark>additional</mark> <mark>speakers</mark>",
          D: "Change the <mark>seminar</mark> <mark>topic</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Send a formal invitation

대본 키워드: "I'll draft a formal invitation and send it by this afternoon."
보기 키워드: "Send a formal invitation"

❌ 오답 트랩:
(B) Postpone the event 
→ 행사 연기 언급 없음

(C) Contact additional speakers 
→ 추가 연사 접촉 언급 없음

(D) Change the seminar topic 
→ 세미나 주제 변경 언급 없음`,
      },
    ],
  },
  conversation2: {
    id: 2,
    title: "Venue Selection",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business2.mp3",
        script: `<mark>W</mark>: Hi, Jake. We <mark>need to finalize a venue for the company's annual conference</mark>. Have you visited the locations we shortlisted?
<span class="translation">(안녕하세요, Jake. 회사 연례 컨퍼런스를 위한 장소를 확정해야 해요. 후보지들을 방문해보셨나요?)</span>

<mark>M</mark>: Yes, I checked two hotels. <mark>The Grandview Hotel has a large ballroom, but it's quite expensive</mark>. <mark>The City Convention Center is more affordable, but parking is limited</mark>.
<span class="translation">(네, 두 호텔을 확인했어요. Grandview Hotel은 큰 연회장이 있지만 꽤 비싸요. City Convention Center는 더 저렴하지만 주차가 제한적이에요.)</span>

<mark>W</mark>: That's tricky. Which one would be more convenient for our attendees?
<span class="translation">(까다롭네요. 어느 쪽이 참석자들에게 더 편리할까요?)</span>

<mark>M</mark>: I'd say the convention center. Most of <mark>our employees take public transportation, so parking won't be a big issue</mark>.
<span class="translation">(컨벤션 센터라고 생각합니다. 대부분의 직원들이 대중교통을 이용하니 주차는 큰 문제가 되지 않을 거예요.)</span>

<mark>W</mark>: That makes sense. Let's go with the City Convention Center.
<span class="translation">(일리가 있네요. 그럼 City Convention Center로 정하죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "<mark>Choosing</mark> a <mark>venue</mark> for a company event",
          B: "<mark>Booking a hotel</mark> for a business trip",
          C: "<mark>Renting</mark> office space for <mark>new employees</mark>",
          D: "<mark>Expanding</mark> the company's <mark>facilities</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Choosing a venue for a company event

대본 키워드: "We need to finalize a venue for the company's annual conference."
보기 키워드: "Choosing a venue for a company event"

❌ 오답 트랩:
(B) Booking a hotel for a business trip 
→ 출장이 아닌 회사 행사를 위한 장소 선택

(C) Renting office space for new employees 
→ 사무실 공간 임대가 아닌 행사 장소 선택

(D) Expanding the company's facilities 
→ 회사 시설 확장이 아닌 행사 장소 선택`,
      },
      {
        id: 2,
        question: "What issue is mentioned about the Grandview Hotel?",
        options: {
          A: "It is already <mark>fully</mark> <mark>booked</mark>",
          B: "It is too <mark>expensive</mark>",
          C: "It does not have enough <mark>meeting rooms</mark>",
          D: "It is located <mark>too far</mark> from the office",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) It is too expensive

대본 키워드: "The Grandview Hotel has a large ballroom, but it's quite expensive."
보기 키워드: "It is too expensive"

❌ 오답 트랩:
(A) It is already fully booked 
→ 예약 완료 언급 없음

(C) It does not have enough meeting rooms 
→ 오히려 큰 연회장이 있다고 함

(D) It is located too far from the office 
→ 위치 관련 언급 없음`,
      },
      {
        id: 3,
        question:
          "What was the main factor in choosing the <mark>City Convention Center</mark>?",
        options: {
          A: "It has better <mark>catering</mark> options",
          B: "It is <mark>closer</mark> to the company's <mark>headquarters</mark>",
          C: "Most employees use <mark>public</mark> <mark>transportation</mark>",
          D: "The company received a <mark>discount</mark> for booking early",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Most employees use public transportation

대본 키워드: "Most of our employees take public transportation, so parking won't be a big issue."
보기 키워드: "Most employees use public transportation"

❌ 오답 트랩:
(A) It has better catering options 
→ 케이터링 서비스 언급 없음

(B) It is closer to the company's headquarters 
→ 본사와의 거리 언급 없음

(D) The company received a discount for booking early 
→ 조기 예약 할인 언급 없음`,
      },
    ],
  },
  conversation3: {
    id: 3,
    title: "Food & Program Arrangements",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business3.mp3",
        script: `<mark>W</mark>: Hi, Jake. <mark>We've finalized the catering company</mark> for the company gala, but we still need to decide on the menu.
<span class="translation">(안녕하세요, Jake. 회사 갈라 행사를 위한 케이터링 업체는 확정했지만, 메뉴는 아직 결정해야 해요.)</span>

<mark>M</mark>: What are the options?
<span class="translation">(어떤 옵션들이 있나요?)</span>

<mark>W</mark>: The choices are a buffet or a plated dinner. The buffet allows more flexibility, while the plated dinner is more formal.
<span class="translation">(뷔페나 정찬 중에서 선택할 수 있어요. 뷔페는 더 유연하고, 정찬은 더 격식있어요.)</span>

<mark>M</mark>: <mark>I think a buffet would be better,</mark> so guests can choose what they like.
<span class="translation">(손님들이 원하는 것을 선택할 수 있으니 뷔페가 더 좋을 것 같아요.)</span>

<mark>W</mark>: That makes sense. Now for the entertainment, we have a live band booked, but we need to decide between a keynote speech and an award ceremony.
<span class="translation">(일리가 있네요. 이제 엔터테인먼트는, 라이브 밴드는 예약했지만 기조연설과 시상식 중에서 결정해야 해요.)</span>

<mark>M</mark>: I'd go with the keynote speech. That will make the event feel more prestigious.
<span class="translation">(기조연설로 하죠. 그게 행사를 더 품격있게 만들 거예요.)</span>

<mark>W</mark>: <mark>Agreed. I'll confirm the menu</mark> and finalize the entertainment plan.
<span class="translation">(동의해요. 메뉴를 확정하고 엔터테인먼트 계획을 마무리하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What decision about the event has already been made?",
        options: {
          A: "The selection of the <mark>catering</mark> <mark>company</mark>",
          B: "The <mark>guest list</mark> has been finalized",
          C: "The <mark>venue</mark> has been changed",
          D: "The <mark>schedule</mark> for the speakers has been set",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The selection of the catering company

대본 키워드: "We've finalized the catering company for the company gala, but we still need to decide on the menu."
보기 키워드: "The selection of the catering company"

❌ 오답 트랩:
(B) The guest list has been finalized 
→ 참석자 명단 논의 없음

(C) The venue has been changed 
→ 장소 변경 관련 언급 없음

(D) The schedule for the speakers has been set 
→ 연설 시간 확정되지 않음`,
      },
      {
        id: 2,
        question: "What meal option does <mark>the man</mark> prefer?",
        options: {
          A: "A <mark>plated dinner</mark>",
          B: "A <mark>vegetarian-only</mark> menu",
          C: "A <mark>buffet</mark>",
          D: "A <mark>custom meal</mark> for each guest",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A buffet

대본 키워드: "I think a buffet would be better, so guests can choose what they like."
보기 키워드: "A buffet"

❌ 오답 트랩:
(A) A plated dinner 
→ 뷔페를 선택했으므로 오답

(B) A vegetarian-only menu 
→ 채식 옵션 논의 없음

(D) A custom meal for each guest 
→ 각각 맞춤식 제공 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Confirm the <mark>keynote speaker</mark>",
          B: "Finalize the <mark>menu</mark>",
          C: "Change the event <mark>venue</mark>",
          D: "Invite <mark>more</mark> <mark>guests</mark> to the event",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Finalize the entertainment plan

대본 키워드: "I'll confirm the menu and finalize the entertainment plan."
보기 키워드: "Finalize the entertainment plan"

❌ 오답 트랩:
(A) Confirm the keynote speaker 
→ 연설자가 아니라 전체 엔터테인먼트 계획을 확정하는 중

(C) Change the event venue 
→ 장소 변경 언급 없음

(D) Invite more guests to the event 
→ 참석자 추가 초대 논의 없음`,
      },
    ],
  },
  conversation4: {
    id: 4,
    title: "Budget Allocation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business4.mp3",
        script: `W: Hi, James. We need to finalize the <mark>advertising budget</mark> for next quarter. Have you reviewed the data?
<span class="translation">(안녕하세요, James. 다음 분기 광고 예산을 확정해야 해요. 데이터를 검토해보셨나요?)</span>

M: Yes. We spent most of our budget on <mark>digital ads</mark> last quarter, but the <mark>return on investment was lower than expected</mark>.
<span class="translation">(네. 지난 분기에는 예산 대부분을 디지털 광고에 썼는데, 투자 수익률이 예상보다 낮았어요.)</span>

W: Maybe we should reallocate some funds. Should we shift more towards TV or radio ads?
<span class="translation">(자금을 재분배해야 할 것 같네요. TV나 라디오 광고에 더 많이 투자할까요?)</span>

M: I'd suggest putting more into targeted online campaigns instead.
<span class="translation">(대신 타겟 온라인 캠페인에 더 많이 투자하는 것을 제안하고 싶습니다.)</span>

W: That makes sense. <mark>I'll update our budget plan</mark> and present it at the next meeting.
<span class="translation">(일리가 있네요. 예산 계획을 수정해서 다음 회의 때 발표하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "Expanding their <mark>customer service</mark> team",
          B: "Adjusting the <mark>marketing budget</mark>",
          C: "Redesigning the <mark>company</mark> <mark>website</mark>",
          D: "Planning an <mark>advertising</mark> <mark>campaign</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Adjusting the marketing budget

대본 키워드: "We need to finalize the advertising budget for next quarter."
보기 키워드: "Adjusting the marketing budget"

❌ 오답 트랩:
(A) Expanding their customer service team 
→ 고객 서비스 확장이 아니라 광고 예산 논의

(C) Redesigning the company website 
→ 웹사이트 리디자인 언급 없음

(D) Planning an advertising campaign 
→ 광고 계획이 아니라 예산 분배 논의 중`,
      },
      {
        id: 2,
        question:
          "What issue does <mark>the man</mark> mention about digital ads?",
        options: {
          A: "They were too <mark>expensive</mark>",
          B: "They <mark>did not</mark> generate expected <mark>returns</mark>",
          C: "They reached <mark>the wrong audience</mark>",
          D: "They were <mark>difficult to track</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) They did not generate expected returns

대본 키워드: "The return on investment was lower than expected."
보기 키워드: "They did not generate expected returns"

❌ 오답 트랩:
(A) They were too expensive 
→ 비용이 아닌 수익률 문제 언급

(C) They reached the wrong audience 
→ 타겟 고객층 문제 언급 없음

(D) They were difficult to track 
→ 추적 어려움 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Revise the advertising <mark>budget</mark> <mark>plan</mark>",
          B: "Approve <mark>additional</mark> <mark>funding</mark>",
          C: "Contact a new <mark>marketing</mark> <mark>agency</mark>",
          D: "Launch a <mark>nationwide</mark> <mark>campaign</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Revise the advertising budget plan

대본 키워드: "I'll update our budget plan and present it at the next meeting."
보기 키워드: "Revise the advertising budget plan"

❌ 오답 트랩:
(B) Approve additional funding 
→ 예산을 늘린다는 언급 없음, 재분배 논의 중

(C) Contact a new marketing agency 
→ 새로운 광고 대행사 접촉 언급 없음

(D) Launch a nationwide campaign 
→ 전국 캠페인 실행이 아니라 예산 조정 논의 중`,
      },
    ],
  },
  conversation5: {
    id: 5,
    title: "Consumer Trend Research",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business5.mp3",
        script: `<mark>M</mark>: Hi, Olivia. I just finished reviewing the latest consumer trend report. There are some interesting insights.
<span class="translation">(안녕하세요, Olivia. 방금 최신 소비자 트렌드 보고서를 검토했는데, 흥미로운 통찰이 있네요.)</span>

<mark>W</mark>: Really? Are there any major changes from last quarter?
<span class="translation">(정말요? 지난 분기와 비교해서 큰 변화가 있나요?)</span>

<mark>M</mark>: Yes. We've seen a significant increase in demand for <mark>eco-friendly packaging</mark>. Consumers are choosing <mark>sustainable options</mark> more than ever.
<span class="translation">(네. 친환경 포장에 대한 수요가 크게 증가했어요. 소비자들이 그 어느 때보다도 지속 가능한 옵션을 선택하고 있어요.)</span>

<mark>W</mark>: That's good to know. Should we adjust our product packaging strategy to match this trend?
<span class="translation">(알아두면 좋겠네요. 이 트렌드에 맞춰 제품 포장 전략을 조정해야 할까요?)</span>

<mark>M</mark>: I think so. We should discuss this with the <mark>product development team</mark>.
<span class="translation">(그래야 할 것 같아요. 제품 개발팀과 이 문제를 논의해봐야겠어요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What topic are <mark>the speakers</mark> discussing?",
        options: {
          A: "A <mark>supply chain</mark> issue",
          B: "A shift in <mark>consumer</mark> <mark>preferences</mark>",
          C: "A change in <mark>government</mark> <mark>regulations</mark>",
          D: "A production <mark>delay</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A shift in consumer preferences

대본 키워드: "We've seen a significant increase in demand for eco-friendly packaging."
보기 키워드: "A shift in consumer preferences"

❌ 오답 트랩:
(A) A supply chain issue 
→ 공급망 문제 언급 없음

(C) A change in government regulations 
→ 정부 규제 변경 언급 없음

(D) A production delay 
→ 생산 지연 관련 언급 없음`,
      },
      {
        id: 2,
        question: "What change has been observed?",
        options: {
          A: "More <mark>consumers</mark> are choosing <mark>sustainable</mark> <mark>products</mark>",
          B: "The <mark>company's sales</mark> have increased significantly",
          C: "<mark>Competitors</mark> are <mark>lowering</mark> their <mark>prices</mark>",
          D: "Customers prefer <mark>faster shipping</mark> over product quality",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) More consumers are choosing sustainable products

대본 키워드: "Consumers are choosing sustainable options more than ever."
보기 키워드: "More consumers are choosing sustainable products"

❌ 오답 트랩:
(B) The company's sales have increased significantly 
→ 회사 매출 증가 언급 없음

(C) Competitors are lowering their prices 
→ 경쟁사 가격 인하 언급 없음

(D) Customers prefer faster shipping over product quality 
→ 배송 속도와 품질 선호도 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the speakers</mark> likely do next?",
        options: {
          A: "Discuss the findings with the <mark>product development team</mark>",
          B: "Launch a new <mark>advertising campaign</mark>",
          C: "Contact suppliers about <mark>pricing</mark> <mark>changes</mark>",
          D: "Conduct another <mark>survey</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Discuss the findings with the product development team

대본 키워드: "We should discuss this with the product development team."
보기 키워드: "Discuss the findings with the product development team"

❌ 오답 트랩:
(B) Launch a new advertising campaign 
→ 새로운 광고 캠페인 언급 없음

(C) Contact suppliers about pricing changes 
→ 공급업체 가격 변경 논의 언급 없음

(D) Conduct another survey 
→ 추가 설문조사 실시 언급 없음`,
      },
    ],
  },
  conversation6: {
    id: 6,
    title: "Competitor Analysis",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business6.mp3",
        script: `<mark>W</mark>: Hi, Jake. I've been researching our <mark>competitors' latest marketing strategies</mark>. They're making some big changes.
<span class="translation">(안녕하세요, Jake. 경쟁사들의 최신 마케팅 전략을 조사해봤는데, 큰 변화들이 있네요.)</span>

<mark>M</mark>: Oh? What kind of changes?
<span class="translation">(오? 어떤 변화들인가요?)</span>

<mark>W</mark>: One of our biggest competitors has <mark>lowered their prices</mark> by 15% and launched a new loyalty program.
<span class="translation">(우리의 가장 큰 경쟁사 중 하나가 가격을 15% 인하하고 새로운 로열티 프로그램을 시작했어요.)</span>

<mark>M</mark>: That's aggressive. Should we consider adjusting our pricing or offering new promotions?
<span class="translation">(공격적이네요. 우리도 가격을 조정하거나 새로운 프로모션을 제공하는 것을 고려해봐야 할까요?)</span>

<mark>W</mark>: It might be a good idea. I'll put together a <mark>competitive analysis report</mark> and present it at the next meeting.
<span class="translation">(좋은 생각인 것 같아요. 경쟁사 분석 보고서를 작성해서 다음 회의 때 발표하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of discussion?",
        options: {
          A: "Evaluating a <mark>competitor's</mark> <mark>strategy</mark>",
          B: "Expanding the company's <mark>operations</mark>",
          C: "Launching a new <mark>product</mark> <mark>line</mark>",
          D: "Reviewing <mark>customer</mark> <mark>complaints</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Evaluating a competitor's strategy

대본 키워드: "I've been researching our competitors' latest marketing strategies."
보기 키워드: "Evaluating a competitor's strategy"

❌ 오답 트랩:
(B) Expanding the company's operations 
→ 회사 운영 확장 논의 없음

(C) Launching a new product line 
→ 새로운 제품 라인 출시 언급 없음

(D) Reviewing customer complaints 
→ 고객 불만 검토 언급 없음`,
      },
      {
        id: 2,
        question: "What action has a competitor taken?",
        options: {
          A: "They have launched a <mark>new</mark> <mark>website</mark>",
          B: "They have reduced their <mark>prices</mark>",
          C: "They have expanded into <mark>new</mark> <mark>markets</mark>",
          D: "They have discontinued a <mark>product</mark> <mark>line</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) They have reduced their prices

대본 키워드: "One of our biggest competitors has lowered their prices by 15%."
보기 키워드: "They have reduced their prices"

❌ 오답 트랩:
(A) They have launched a new website 
→ 새 웹사이트 론칭 언급 없음

(C) They have expanded into new markets 
→ 새로운 시장 확장 언급 없음

(D) They have discontinued a product line 
→ 제품 라인 중단 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> likely do next?",
        options: {
          A: "Prepare a <mark>competitor</mark> <mark>analysis</mark> report",
          B: "<mark>Contact</mark> the <mark>competitor</mark> for more information",
          C: "Launch a <mark>price-matching</mark> <mark>policy</mark>",
          D: "Recommend reducing <mark>production</mark> <mark>costs</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Prepare a competitor analysis report

대본 키워드: "I'll put together a competitive analysis report and present it at the next meeting."
보기 키워드: "Prepare a competitor analysis report"

❌ 오답 트랩:
(B) Contact the competitor for more information 
→ 경쟁사 접촉 언급 없음

(C) Launch a price-matching policy 
→ 가격 매칭 정책 시행 언급 없음

(D) Recommend reducing production costs 
→ 생산 비용 절감 제안 언급 없음`,
      },
    ],
  },
  conversation7: {
    id: 7,
    title: "Survey Results Review",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business7.mp3",
        script: `<mark>M</mark>: Hi, Sarah. I just reviewed the latest <mark>customer survey results</mark>. There's some useful feedback.
<span class="translation">(안녕하세요, Sarah. 방금 최신 고객 설문조사 결과를 검토했는데, 유용한 피드백이 있네요.)</span>

<mark>W</mark>: Great. What stood out the most?
<span class="translation">(좋네요. 가장 두드러진 점은 무엇인가요?)</span>

<mark>M</mark>: Customers liked our products, but many of them said our <mark>website is difficult to navigate</mark>.
<span class="translation">(고객들은 우리 제품을 좋아했지만, 많은 분들이 웹사이트 탐색이 어렵다고 말씀하셨어요.)</span>

<mark>W</mark>: That's something we should address. Should we consider a redesign?
<span class="translation">(그건 해결해야 할 문제네요. 리디자인을 고려해볼까요?)</span>

<mark>M</mark>: Maybe. Let's discuss the details in the next <mark>team meeting</mark>.
<span class="translation">(아마도요. 다음 팀 회의에서 자세히 논의해보죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A decline in <mark>product quality</mark>",
          B: "Complaints about an <mark>online platform</mark>",
          C: "A review of company <mark>financials</mark>",
          D: "Feedback from a <mark>customer survey</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Feedback from a customer survey

대본 키워드: "I just reviewed the latest customer survey results."
보기 키워드: "Feedback from a customer survey"

❌ 오답 트랩:
(A) A decline in product quality 
→ 제품 품질 저하가 아니라 웹사이트 사용성 문제

(B) Complaints about an online platform 
→ 웹사이트 문제와 유사하지만, 특정 플랫폼 문제라고 단정하기 어려움

(C) A review of company financials 
→ 재무 검토 언급 없음`,
      },
      {
        id: 2,
        question: "What issue did customers mention?",
        options: {
          A: "The <mark>return policy</mark> is unclear",
          B: "The <mark>company's website</mark> is difficult to use",
          C: "The <mark>pricing</mark> is too high",
          D: "The <mark>product variety</mark> is too limited",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The company's website is difficult to use

대본 키워드: "Many of them said our website is difficult to navigate."
보기 키워드: "The company's website is difficult to use"

❌ 오답 트랩:
(A) The return policy is unclear 
→ 환불 정책 관련 언급 없음

(C) The pricing is too high 
→ 가격 문제 언급 없음

(D) The product variety is too limited 
→ 제품 종류 관련 피드백 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the speakers</mark> likely do next?",
        options: {
          A: "Offer <mark>discounts</mark> to customers",
          B: "Send out another <mark>survey</mark>",
          C: "Discuss the issue in a <mark>team meeting</mark>",
          D: "Change the company's <mark>refund</mark> <mark>policy</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Discuss the issue in a team meeting

대본 키워드: "Let's discuss the details in the next team meeting."
보기 키워드: "Discuss the issue in a team meeting"

❌ 오답 트랩:
(A) Offer discounts to customers 
→ 할인 제공 논의 없음

(B) Send out another survey 
→ 추가 설문조사 계획 언급 없음

(D) Change the company's refund policy 
→ 환불 정책 변경 논의 없음`,
      },
    ],
  },
  conversation8: {
    id: 8,
    title: "Planning a Training Session",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business8.mp3",
        script: `<mark>M</mark>: Hi, Olivia. We need to finalize the topics for next month's <mark>leadership training</mark>. Have we gathered input from department heads?
<span class="translation">(안녕하세요, Olivia. 다음 달 리더십 교육 주제를 확정해야 하는데요. 부서장들의 의견은 모았나요?)</span>

<mark>W</mark>: Yes, we received their feedback. Most teams want sessions on <mark>conflict resolution and performance management</mark>.
<span class="translation">(네, 피드백을 받았어요. 대부분의 팀이 갈등 해결과 성과 관리에 대한 세션을 원하더라고요.)</span>

<mark>M</mark>: That makes sense. Should we offer separate sessions for managers and employees, or keep them combined?
<span class="translation">(일리가 있네요. 관리자와 직원들을 위한 세션을 따로 진행할까요, 아니면 함께 할까요?)</span>

<mark>W</mark>: I think it's better to separate them. That way, the discussions will be more relevant to each group.
<span class="translation">(따로 하는 게 좋을 것 같아요. 그래야 각 그룹에 더 적절한 논의가 이루어질 수 있을 것 같아요.)</span>

<mark>M</mark>: Agreed. I'll <mark>update the schedule</mark> and send it to HR for approval.
<span class="translation">(동의합니다. 일정을 업데이트해서 인사팀의 승인을 받도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "The <mark>venue</mark> for an upcoming event",
          B: "Topics for a <mark>leadership training</mark> program",
          C: "<mark>Employee</mark> evaluations and feedback",
          D: "A new <mark>hiring</mark> <mark>policy</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Topics for a leadership training program

대본 키워드: "We need to finalize the topics for next month's leadership training."
보기 키워드: "Topics for a leadership training program"

❌ 오답 트랩:
(A) The venue for an upcoming event 
→ 장소가 아니라 교육 주제 논의 중

(C) Employee evaluations and feedback 
→ 평가 및 피드백이 아니라 교육 프로그램 논의

(D) A new hiring policy 
→ 채용 정책 언급 없음`,
      },
      {
        id: 2,
        question: "What topics are suggested for the training?",
        options: {
          A: "<mark>Conflict resolution</mark> and performance management",
          B: "<mark>Time management</mark> and customer service",
          C: "<mark>Financial planning</mark> and budgeting",
          D: "<mark>Public speaking</mark> and team building",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Conflict resolution and performance management

대본 키워드: "Most teams want sessions on conflict resolution and performance management."
보기 키워드: "Conflict resolution and performance management"

❌ 오답 트랩:
(B) Time management and customer service 
→ 시간 관리와 고객 서비스 언급 없음

(C) Financial planning and budgeting 
→ 재무 계획과 예산 관리 언급 없음

(D) Public speaking and team building 
→ 대중 연설과 팀 빌딩 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> do next?",
        options: {
          A: "Update the <mark>training schedule</mark>",
          B: "Find a <mark>speaker</mark> for the event",
          C: "Reserve a <mark>venue</mark> for the sessions",
          D: "Notify employees about the <mark>training</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Update the training schedule

대본 키워드: "I'll update the schedule and send it to HR for approval."
보기 키워드: "Update the training schedule"

❌ 오답 트랩:
(B) Find a speaker for the event 
→ 연사 섭외 언급 없음

(C) Reserve a venue for the sessions 
→ 장소 예약 언급 없음

(D) Notify employees about the training 
→ 직원들에게 통지 언급 없음`,
      },
    ],
  },
  conversation9: {
    id: 9,
    title: "File Storage System Discussion",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business9.mp3",
        script: `<mark>M</mark>: Hey, I wanted to discuss our current file-sharing system. Some employees mentioned that it's difficult to <mark>locate documents</mark> when they need them.
<span class="translation">(안녕하세요, 현재 파일 공유 시스템에 대해 논의하고 싶습니다. 직원들이 필요할 때 문서를 찾기 어렵다고 말했거든요.)</span>

<mark>W</mark>: Yes, I've also noticed that. Since we're using multiple storage platforms, files are often <mark>scattered and hard to track</mark>.
<span class="translation">(네, 저도 알고 있어요. 여러 저장 플랫폼을 사용하다 보니 파일들이 흩어져 있어서 추적하기 어렵더라고요.)</span>

<mark>M</mark>: Right. I think we should switch to a centralized <mark>cloud-based storage system</mark>. That way, everything will be in one place.
<span class="translation">(맞아요. 중앙화된 클라우드 기반 저장 시스템으로 전환해야 할 것 같아요. 그러면 모든 것이 한 곳에 있게 될 거예요.)</span>

<mark>W</mark>: That sounds like a great idea. Do you know how much that would cost?
<span class="translation">(좋은 생각인 것 같아요. 비용이 얼마나 들지 아시나요?)</span>

<mark>M</mark>: I'm not sure, but I'll check with the IT department. If the cost is reasonable, we could start the transition next month.
<span class="translation">(잘 모르겠지만, IT 부서에 확인해보겠습니다. 비용이 적절하다면 다음 달부터 전환을 시작할 수 있을 거예요.)</span>

<mark>W</mark>: That would be great. In the meantime, I'll send out a <mark>survey</mark> to see what <mark>features employees would find most useful</mark>.
<span class="translation">(좋네요. 그동안 직원들이 어떤 기능을 가장 유용하게 생각하는지 설문조사를 보내보겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem are the speakers discussing?",
        options: {
          A: "Employees are struggling to find <mark>files</mark>",
          B: "The company's <mark>Internet</mark> <mark>connection</mark> is <mark>slow</mark>",
          C: "Some team members missed an important <mark>deadline</mark>",
          D: "The office lacks enough <mark>storage</mark> <mark>space</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Employees are struggling to find files

대본 키워드: "difficult to locate documents", "files are scattered and hard to track"
보기 키워드: "struggling to find files"

❌ 오답 트랩:
(B) The company's Internet connection is slow 
→ 인터넷 속도 문제가 아닌 파일 찾기 어려움

(C) Some team members missed an important deadline 
→ 마감 기한 문제가 아닌 파일 찾기 어려움

(D) The office lacks enough storage space 
→ 저장 공간 부족이 아닌 파일 찾기 어려움`,
      },
      {
        id: 2,
        question: "What does <mark>the man</mark> propose?",
        options: {
          A: "Hiring additional <mark>IT</mark> <mark>staff</mark>",
          B: "Switching to a <mark>cloud-based</mark> <mark>system</mark>",
          C: "<mark>Upgrading</mark> the company's <mark>computers</mark>",
          D: "Installing a <mark>new</mark> <mark>printer</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Switching to a cloud-based system

대본 키워드: "switch to a centralized cloud-based storage system"
보기 키워드: "Switching to a cloud-based system"

❌ 오답 트랩:
(A) Hiring additional IT staff 
→ IT 인력 채용이 아닌 클라우드 시스템 도입

(C) Upgrading the company's computers 
→ 컴퓨터 업그레이드가 아닌 클라우드 시스템 도입

(D) Installing a new printer 
→ 프린터 설치가 아닌 클라우드 시스템 도입`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Request a <mark>budget</mark> proposal from <mark>IT</mark>",
          B: "Ask employees for their <mark>feedback</mark>",
          C: "Begin moving files to the <mark>new</mark> <mark>system</mark>",
          D: "Schedule a <mark>training session</mark> for staff",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Ask employees for their feedback

대본 키워드: "I'll send out a survey to see what features employees would find most useful"
보기 키워드: "Ask employees for their feedback"

❌ 오답 트랩:
(A) Request a budget proposal from IT 
→ IT 부서 예산 요청이 아닌 직원 설문조사

(C) Begin moving files to the new system 
→ 파일 이동이 아닌 직원 설문조사

(D) Schedule a training session for staff 
→ 교육 일정이 아닌 직원 설문조사`,
      },
    ],
  },
  conversation10: {
    id: 10,
    title: "Product Launch Event Planning",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business10.mp3",
        script: `<mark>M</mark>: We need to finalize the details for our upcoming <mark>product launch event</mark>. Have we decided on a date yet?
<span class="translation">(다가오는 제품 출시 행사의 세부사항을 확정해야 합니다. 날짜는 정해졌나요?)</span>

<mark>W</mark>: Yes, we're looking at the second weekend of next month. That way, we'll have enough time to set everything up.
<span class="translation">(네, 다음 달 둘째 주말로 생각하고 있어요. 그러면 모든 것을 준비할 시간이 충분할 거예요.)</span>

<mark>M</mark>: That works. What about the venue? I know we were considering the city convention center.
<span class="translation">(좋습니다. 장소는 어떻게 됐나요? 시립 컨벤션 센터를 고려하고 있었잖아요.)</span>

<mark>W</mark>: Actually, we decided on the <mark>Grand Hotel ballroom</mark> instead. It's more affordable, and it has the space we need.
<span class="translation">(사실, 대신 그랜드 호텔 연회장으로 결정했어요. 더 저렴하고 필요한 공간도 있거든요.)</span>

<mark>M</mark>: Sounds good. Now, how should we promote the event? We could send out email invitations to our client list.
<span class="translation">(좋네요. 이제 행사를 어떻게 홍보할까요? 고객 목록으로 이메일 초대장을 보낼 수 있겠죠.)</span>

<mark>W</mark>: That's a great idea. I'll also coordinate with the <mark>social media team</mark> to boost online engagement.
<span class="translation">(좋은 생각이에요. 저는 온라인 참여도를 높이기 위해 소셜 미디어 팀과 협력하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers mainly discussing?",
        options: {
          A: "A <mark>new</mark> <mark>advertising</mark> <mark>campaign</mark>",
          B: "A sales report for the <mark>last</mark> <mark>quarter</mark>",
          C: "A promotional event for a <mark>product</mark> <mark>launch</mark>",
          D: "A redesign of a company <mark>website</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A promotional event for a product launch

대본 키워드: "finalize the details for our upcoming product launch event"
보기 키워드: "A promotional event for a product launch"

❌ 오답 트랩:
(A) A new advertising campaign 
→ 광고 캠페인이 아닌 제품 출시 행사

(B) A sales report for the last quarter 
→ 매출 보고가 아닌 제품 출시 행사

(D) A redesign of a company website 
→ 웹사이트 리디자인이 아닌 제품 출시 행사`,
      },
      {
        id: 2,
        question: "Where will the event take place?",
        options: {
          A: "At the <mark>city</mark> <mark>convention</mark> <mark>center</mark>",
          B: "At an outdoor <mark>venue</mark>",
          C: "At a <mark>hotel</mark> <mark>ballroom</mark>",
          D: "At the company <mark>headquarters</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) At a hotel ballroom

대본 키워드: "we decided on the Grand Hotel ballroom instead"
보기 키워드: "At a hotel ballroom"

❌ 오답 트랩:
(A) At the city convention center 
→ 컨벤션 센터가 아닌 호텔 연회장으로 변경됨

(B) At an outdoor venue 
→ 야외 장소가 아닌 호텔 연회장

(D) At the company headquarters 
→ 회사 본사가 아닌 호텔 연회장`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Book the event <mark>venue</mark>",
          B: "Confirm the <mark>guest</mark> <mark>list</mark>",
          C: "<mark>Distribute flyers</mark> around the office",
          D: "Work with the <mark>social media</mark> <mark>team</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Work with the social media team

대본 키워드: "I'll also coordinate with the social media team"
보기 키워드: "Work with the social media team"

❌ 오답 트랩:
(A) Book the event venue 
→ 장소 예약이 아닌 소셜 미디어 팀과 협업

(B) Confirm the guest list 
→ 게스트 리스트 확인이 아닌 소셜 미디어 팀과 협업

(C) Distribute flyers around the office 
→ 전단지 배포가 아닌 소셜 미디어 팀과 협업`,
      },
    ],
  },
  conversation11: {
    id: 11,
    title: "Business Proposal Discussion",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business11.mp3",
        script: `<mark>M</mark>: We need to finalize the <mark>proposal</mark> for the prospective client. Have we decided what key points to include?
<span class="translation">(잠재 고객을 위한 제안서를 마무리해야 합니다. 어떤 핵심 사항을 포함할지 결정했나요?)</span>

<mark>W</mark>: Yes, we should highlight our latest service updates and a <mark>customized solution</mark> for their business needs.
<span class="translation">(네, 최신 서비스 업데이트와 그들의 비즈니스 요구에 맞는 맞춤형 솔루션을 강조해야 할 것 같아요.)</span>

<mark>M</mark>: That makes sense. What about pricing? Should we offer a discount to encourage them to sign a contract?
<span class="translation">(그렇군요. 가격은 어떻게 할까요? 계약 체결을 유도하기 위해 할인을 제공할까요?)</span>

<mark>W</mark>: I think so. If they agree to a two-year contract, we could offer a <mark>10% discount</mark>.
<span class="translation">(그래야 할 것 같아요. 2년 계약에 동의하면 10% 할인을 제공할 수 있을 것 같아요.)</span>

<mark>M</mark>: That sounds reasonable. I'll include that in the proposal. Do we have all the necessary details to send it out?
<span class="translation">(합리적인 것 같네요. 제안서에 그 내용을 포함시키겠습니다. 발송하는데 필요한 모든 세부사항이 있나요?)</span>

<mark>W</mark>: Almost. I'll <mark>double-check the document</mark> for accuracy and forward it to you this afternoon.
<span class="translation">(거의요. 정확성을 위해 문서를 다시 한 번 확인하고 오후에 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers discussing?",
        options: {
          A: "A <mark>customer complaint</mark> about a service",
          B: "A company's <mark>financial</mark> <mark>performance</mark>",
          C: "A <mark>business proposal</mark> for a potential client",
          D: "A <mark>job</mark> candidate's <mark>application</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A business proposal for a potential client

대본 키워드: "finalize the proposal for the prospective client"
보기 키워드: "A business proposal for a potential client"

❌ 오답 트랩:
(A) A customer complaint about a service 
→ 고객 불만이 아닌 잠재 고객 제안서

(B) A company's financial performance 
→ 재무 성과가 아닌 잠재 고객 제안서

(D) A job candidate's application 
→ 입사 지원이 아닌 잠재 고객 제안서`,
      },
      {
        id: 2,
        question: "What discount will be offered?",
        options: {
          A: "A <mark>5%</mark> discount on <mark>all</mark> <mark>purchases</mark>",
          B: "A discount for <mark>first-time</mark> <mark>customers</mark>",
          C: "A <mark>10%</mark> discount for a <mark>long-term</mark> <mark>contract</mark>",
          D: "A <mark>seasonal</mark> promotion <mark>discount</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A 10% discount for a long-term contract

대본 키워드: "If they agree to a two-year contract, we could offer a 10% discount"
보기 키워드: "A 10% discount for a long-term contract"

❌ 오답 트랩:
(A) A 5% discount on all purchases 
→ 5% 할인이 아닌 10% 할인

(B) A discount for first-time customers 
→ 첫 구매 할인이 아닌 장기 계약 할인

(D) A seasonal promotion discount 
→ 시즌 할인이 아닌 장기 계약 할인`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "<mark>Review the proposal</mark> before sending it",
          B: "Contact the client for a follow-up <mark>meeting</mark>",
          C: "Ask for approval from the <mark>finance</mark> <mark>department</mark>",
          D: "Research the <mark>competitor's</mark> <mark>pricing</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Review the proposal before sending it

대본 키워드: "I'll double-check the document for accuracy and forward it"
보기 키워드: "Review the proposal before sending it"

❌ 오답 트랩:
(B) Contact the client for a follow-up meeting 
→ 후속 미팅이 아닌 제안서 검토

(C) Ask for approval from the finance department 
→ 재무부서 승인이 아닌 제안서 검토

(D) Research the competitor's pricing 
→ 경쟁사 가격 조사가 아닌 제안서 검토`,
      },
    ],
  },
  conversation12: {
    id: 12,
    title: "Marketing and Development Coordination",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business12.mp3",
        script: `M: Hi, Lisa. We need to align the marketing campaign with the product launch. Do you have an <mark>update on the development timeline</mark>?
<span class="translation">(안녕하세요, Lisa. 마케팅 캠페인을 제품 출시와 맞춰야 해요. 개발 일정에 대한 업데이트가 있나요?)</span>

W: <mark>Yes, the development team is on track</mark>, but we may need an extra week for testing before the release.
<span class="translation">(네, 개발팀은 일정대로 진행 중이지만, 출시 전에 테스트를 위해 일주일이 더 필요할 것 같아요.)</span>

M: I see. That might delay our advertising schedule. <mark>Would it be possible to run a pre-launch promotion</mark> while testing is completed?
<span class="translation">(그렇군요. 그러면 광고 일정이 지연될 수 있겠네요. 테스트가 완료되는 동안 사전 프로모션을 진행하는 건 어떨까요?)</span>

W: That sounds reasonable. We can start creating promotional content and adjust the main campaign as needed.
<span class="translation">(합리적인 것 같네요. 프로모션 콘텐츠를 만들기 시작하고 필요에 따라 메인 캠페인을 조정할 수 있겠어요.)</span>

M: Great. Can you share the revised timeline with my team? That way, we can sync everything properly.
<span class="translation">(좋아요. 수정된 일정을 우리 팀과 공유해 주실 수 있나요? 그러면 모든 것을 제대로 동기화할 수 있을 것 같아요.)</span>

W: Sure! <mark>I'll send you an updated schedule</mark> by this afternoon.
<span class="translation">(물론이죠! 오후까지 업데이트된 일정을 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation mainly about?",
        options: {
          A: "A <mark>budget</mark> discussion for a <mark>new</mark> <mark>project</mark>",
          B: "<mark>Coordinating</mark> efforts between <mark>departments</mark>",
          C: "A <mark>delay</mark> in manufacturing a product",
          D: "<mark>Hiring</mark> <mark>new</mark> employees for the <mark>marketing</mark> <mark>team</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Coordinating efforts between departments


마케팅팀(marketing campaign, advertising)과 개발팀(development team, testing) 간의 일정 조율이 주제."


❌ 오답 트랩:
(A) A budget discussion for a new project 
→ 예산 논의가 아닌 부서 간 협업 조율

(C) A delay in manufacturing a product 
→ 제조 지연이 아닌 부서 간 협업 조율

(D) Hiring new employees for the marketing team 
→ 신규 채용이 아닌 부서 간 협업 조율`,
      },
      {
        id: 2,
        question: "What does <mark>the man</mark> suggest doing?",
        options: {
          A: "<mark>Moving</mark> up <mark>the launch</mark> <mark>date</mark>",
          B: "Running a <mark>promotion</mark> <mark>before</mark> <mark>the release</mark>",
          C: "Extending <mark>the testing</mark> <mark>phase</mark>",
          D: "<mark>Changing</mark> the product <mark>features</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Running a promotion before the release

대본 키워드: "run a pre-launch promotion while testing is completed"
보기 키워드: "Running a promotion before the release"

❌ 오답 트랩:
(A) Moving up the launch date 
→ 출시일 앞당기기가 아닌 사전 프로모션 진행

(C) Extending the testing phase 
→ 테스트 기간 연장이 아닌 사전 프로모션 진행

(D) Changing the product features 
→ 제품 기능 변경이 아닌 사전 프로모션 진행`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Send an <mark>updated</mark> <mark>timeline</mark>",
          B: "Contact the <mark>manufacturing</mark> <mark>team</mark>",
          C: "Approve the <mark>final</mark> <mark>budget</mark>",
          D: "Schedule a meeting with <mark>designers</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Send an updated timeline

대본 키워드: "I'll send you an updated schedule by this afternoon"
보기 키워드: "Send an updated timeline"

❌ 오답 트랩:
(B) Contact the manufacturing team 
→ 제조팀 연락이 아닌 일정 업데이트 전송

(C) Approve the final budget 
→ 예산 승인이 아닌 일정 업데이트 전송

(D) Schedule a meeting with designers 
→ 디자이너 미팅이 아닌 일정 업데이트 전송`,
      },
    ],
  },
  conversation13: {
    id: 13,
    title: "Meeting Rescheduling Discussion",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business13.mp3",
        script: `<mark>M</mark>: Hi, Sarah. I just heard that the client won't be able to make it to our scheduled <mark>meeting</mark> on Friday morning.
<span class="translation">(안녕하세요, Sarah. 방금 고객이 금요일 아침 예정된 회의에 참석할 수 없다고 들었어요.)</span>

<mark>W</mark>: Oh, that's unfortunate. Do they have a preferred time for rescheduling?
<span class="translation">(아, 유감이네요. 일정 변경을 위해 선호하는 시간이 있나요?)</span>

<mark>M</mark>: They suggested <mark>Friday afternoon</mark> instead. Would that work for the rest of our team?
<span class="translation">(대신 금요일 오후를 제안했어요. 우리 팀 나머지 인원들은 괜찮을까요?)</span>

<mark>W</mark>: I believe so, but I'll double-check with them. Also, we originally booked the main conference room, but it won't be available in the afternoon.
<span class="translation">(그럴 것 같지만, 다시 한 번 확인해볼게요. 그리고 원래 메인 회의실을 예약했는데, 오후에는 사용할 수 없어요.)</span>

<mark>M</mark>: Hmm, then we'll need to find another location. Can you check if the second-floor <mark>meeting room</mark> is free?
<span class="translation">(음, 그러면 다른 장소를 찾아야겠네요. 2층 회의실이 비어있는지 확인해주실 수 있나요?)</span>

<mark>W</mark>: Sure! I'll <mark>confirm the availability</mark> and update the calendar.
<span class="translation">(물론이죠! 가용성을 확인하고 일정표를 업데이트하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem do the speakers discuss?",
        options: {
          A: "A <mark>scheduling</mark> <mark>conflict</mark>",
          B: "A missing <mark>presentation</mark> <mark>file</mark>",
          C: "A <mark>delay</mark> in a project <mark>deadline</mark>",
          D: "An issue with the venue's <mark>internet</mark> <mark>connection</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A scheduling conflict

대본 키워드: "client won't be able to make it to our scheduled meeting"
보기 키워드: "A scheduling conflict"

❌ 오답 트랩:
(B) A missing presentation file 
→ 프레젠테이션 파일이 아닌 일정 충돌

(C) A delay in a project deadline 
→ 프로젝트 기한이 아닌 일정 충돌

(D) An issue with the venue's internet connection 
→ 인터넷 연결이 아닌 일정 충돌`,
      },
      {
        id: 2,
        question: "What does <mark>the client</mark> suggest instead??",
        options: {
          A: "Moving the meeting to <mark>Friday</mark> <mark>afternoon</mark>",
          B: "<mark>Canceling the meeting</mark> altogether",
          C: "Sending a <mark>summary</mark> of the discussion via <mark>email</mark>",
          D: "Holding the <mark>meeting outside</mark> the office",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Moving the meeting to Friday afternoon

대본 키워드: "They suggested Friday afternoon instead"
보기 키워드: "Moving the meeting to Friday afternoon"

❌ 오답 트랩:
(B) Canceling the meeting altogether 
→ 회의 취소가 아닌 오후로 변경

(C) Sending a summary of the discussion via email 
→ 이메일 요약이 아닌 오후로 변경

(D) Holding the meeting outside the office 
→ 외부 회의가 아닌 오후로 변경`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Confirm the availability of a <mark>meeting</mark> <mark>room</mark>",
          B: "Contact the client for a <mark>new</mark> <mark>proposal</mark>",
          C: "<mark>Send invitations</mark> for a company-wide event",
          D: "Reserve <mark>catering services</mark> for the meeting",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Confirm the availability of a meeting room

대본 키워드: "I'll confirm the availability and update the calendar"
보기 키워드: "Confirm the availability of a meeting room"

❌ 오답 트랩:
(B) Contact the client for a new proposal 
→ 고객 연락이 아닌 회의실 확인

(C) Send invitations for a company-wide event 
→ 초대장 발송이 아닌 회의실 확인

(D) Reserve catering services for the meeting 
→ 케이터링 예약이 아닌 회의실 확인`,
      },
    ],
  },
  conversation14: {
    id: 14,
    title: "Client Feedback Discussion",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business14.mp3",
        script: `<mark>M</mark>: Hi, Kate. I just reviewed the <mark>feedback</mark> we received from the client regarding our latest project.
<span class="translation">(안녕하세요, Kate. 방금 최근 프로젝트에 대해 고객으로부터 받은 피드백을 검토했어요.)</span>

<mark>W</mark>: Oh, I saw that <mark>email</mark> too. They mentioned that the report lacked detailed <mark>financial analysis</mark>.
<span class="translation">(아, 저도 그 이메일을 봤어요. 보고서에 상세한 재무 분석이 부족하다고 언급했더라고요.)</span>

<mark>M</mark>: Right. They suggested adding more data to support our conclusions. Should we update the report and resend it?
<span class="translation">(맞아요. 결론을 뒷받침할 데이터를 더 추가하자고 제안했어요. 보고서를 업데이트해서 다시 보내야 할까요?)</span>

<mark>W</mark>: Yes, but let's also clarify some of their concerns in our response email. That might help address their questions before we finalize the document.
<span class="translation">(네, 하지만 답장 이메일에 그들의 우려사항도 명확히 해명하면 좋겠어요. 문서를 완성하기 전에 질문들을 해결하는 데 도움이 될 것 같아요.)</span>

<mark>M</mark>: Good idea. I'll revise the report today. Can you handle drafting the reply?
<span class="translation">(좋은 생각이에요. 제가 오늘 보고서를 수정할게요. 답장 초안을 작성해주실 수 있나요?)</span>

<mark>W</mark>: Sure! I'll send the <mark>email</mark> after reviewing your updates.
<span class="translation">(물론이죠! 수정된 내용을 검토한 후에 이메일을 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation mainly about?",
        options: {
          A: "A <mark>delay</mark> in a product <mark>shipment</mark>",
          B: "A new company-wide <mark>policy</mark>",
          C: "A meeting with a potential <mark>client</mark>",
          D: "<mark>Feedback</mark> received via <mark>email</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Feedback received via email

대본 키워드: "reviewed the feedback we received from the client", "I saw that email too"
보기 키워드: "Feedback received via email"

❌ 오답 트랩:
(A) A delay in a product shipment 
→ 제품 배송이 아닌 이메일 피드백

(B) A new company-wide policy 
→ 회사 정책이 아닌 이메일 피드백

(C) A meeting with a potential client 
→ 잠재 고객 미팅이 아닌 이메일 피드백`,
      },
      {
        id: 2,
        question: "What issue did the client mention?",
        options: {
          A: "The company's <mark>pricing structure</mark> is unclear",
          B: "The project was completed <mark>later than</mark> <mark>expected</mark>",
          C: "The report contained <mark>incorrect</mark> <mark>data</mark>",
          D: "The <mark>financial</mark> <mark>analysis</mark> was <mark>insufficient</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) The financial analysis was insufficient

대본 키워드: "the report lacked detailed financial analysis"
보기 키워드: "The financial analysis was insufficient"

❌ 오답 트랩:
(A) The company's pricing structure is unclear 
→ 가격 구조가 아닌 재무 분석 부족

(B) The project was completed later than expected 
→ 프로젝트 지연이 아닌 재무 분석 부족

(C) The report contained incorrect data 
→ 잘못된 데이터가 아닌 재무 분석 부족`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Send a response <mark>email</mark>",
          B: "Schedule a <mark>follow-up call</mark> with the client",
          C: "Request additional data from the <mark>finance</mark> <mark>team</mark>",
          D: "Discuss the feedback with <mark>senior</mark> <mark>management</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Send a response email

대본 키워드: "I'll send the email after reviewing your updates"
보기 키워드: "Send a response email"

❌ 오답 트랩:
(B) Schedule a follow-up call with the client 
→ 후속 전화가 아닌 이메일 발송

(C) Request additional data from the finance team 
→ 데이터 요청이 아닌 이메일 발송

(D) Discuss the feedback with senior management 
→ 관리자 논의가 아닌 이메일 발송`,
      },
    ],
  },

  conversation15: {
    id: 15,
    title: "Office Chair Purchase Negotiation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/business/business15.mp3",
        script: `<mark>M</mark>: Hello, I'm interested in purchasing 20 units of your office chairs for my company. I noticed that the listed price is $150 per chair. Do you offer any <mark>discounts</mark> for bulk orders?
<span class="translation">(안녕하세요, 우리 회사를 위해 사무용 의자 20개를 구매하고 싶습니다. 개당 가격이 150달러로 되어 있던데요. 대량 주문 시 할인이 가능한가요?)</span>

<mark>W</mark>: Yes, we do. For an order of that size, we can offer a <mark>10% discount</mark>. That would bring the price down to $135 per unit.
<span class="translation">(네, 가능합니다. 그 정도 수량이면 10% 할인을 제공할 수 있어요. 그러면 개당 가격이 135달러가 됩니다.)</span>

<mark>M</mark>: That's helpful, but I was hoping for a slightly better deal. Could you include free shipping as well?
<span class="translation">(도움이 되네요, 하지만 조금 더 좋은 조건을 기대했는데요. 무료 배송도 포함해 주실 수 있나요?)</span>

<mark>W</mark>: Let me check… Yes, we can provide <mark>free shipping</mark> if you place the order by the end of this week.
<span class="translation">(확인해보겠습니다... 네, 이번 주 말까지 주문하시면 무료 배송을 제공할 수 있습니다.)</span>

<mark>M</mark>: That sounds good. I'll finalize the order with my team and get back to you tomorrow.
<span class="translation">(좋습니다. 팀과 상의해서 내일 다시 연락드리겠습니다.)</span>

<mark>W</mark>: Great! I'll prepare the necessary <mark>paperwork</mark> in the meantime.
<span class="translation">(좋습니다! 그동안 필요한 서류를 준비해두겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> trying to do?",
        options: {
          A: "Negotiate a <mark>discount</mark>",
          B: "<mark>Return</mark> a product",
          C: "Request a product <mark>demonstration</mark>",
          D: "Inquire about a <mark>refund</mark> <mark>policy</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Negotiate a discount

대본 키워드: "Do you offer any discounts for bulk orders?"
보기 키워드: "Negotiate a discount"

❌ 오답 트랩:
(B) Return a product 
→ 제품 반품이 아닌 할인 협상

(C) Request a product demonstration 
→ 제품 시연이 아닌 할인 협상

(D) Inquire about a refund policy 
→ 환불 정책이 아닌 할인 협상`,
      },
      {
        id: 2,
        question: "What discount does <mark>the woman</mark> offer?",
        options: {
          A: "A <mark>10%</mark> <mark>price</mark> <mark>reduction</mark>",
          B: "A free extended <mark>warranty</mark>",
          C: "A lower price for <mark>future</mark> <mark>purchases</mark>",
          D: "A <mark>buy-one-get-one-free</mark> deal",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A 10% price reduction

대본 키워드: "we can offer a 10% discount"
보기 키워드: "A 10% price reduction"

❌ 오답 트랩:
(B) A free extended warranty 
→ 보증 연장이 아닌 10% 할인

(C) A lower price for future purchases 
→ 미래 구매 할인이 아닌 10% 할인

(D) A buy-one-get-one-free deal 
→ 1+1 할인이 아닌 10% 할인`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Send an <mark>invoice</mark> for the purchase",
          B: "Offer an additional <mark>discount</mark>",
          C: "Contact the <mark>warehouse</mark> about inventory",
          D: "<mark>Prepare paperwork</mark> for the order",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Prepare paperwork for the order

대본 키워드: "I'll prepare the necessary paperwork in the meantime"
보기 키워드: "Prepare paperwork for the order"

❌ 오답 트랩:
(A) Send an invoice for the purchase 
→ 청구서 발송이 아닌 서류 준비

(B) Offer an additional discount 
→ 추가 할인이 아닌 서류 준비

(C) Contact the warehouse about inventory 
→ 재고 확인이 아닌 서류 준비`,
      },
    ],
  },
};
